var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.7,
    height: 19.7,
    viewBox: "0 0 23.7 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1015",
    "data-name": "Rectangle 1015",
    width: 23.7,
    height: 19.7,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00246a",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M22.85,15.851a3,3,0,0,1-3,3h-16a3,3,0,0,1-3-3v-9a3,3,0,0,1,3-3H6.316a1,1,0,0,0,.83-.444L8.4,1.519a1.5,1.5,0,0,1,1.25-.67h4.338a1.6,1.6,0,0,1,1.334.715L16.554,3.4a1,1,0,0,0,.83.444h2.468a3,3,0,0,1,3,3Z",
    fill: "none",
    stroke: "#00246a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(7.85 6.85)",
    fill: "none",
    stroke: "#00246a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/PhotoIcon.bc37499c6162134f7cc7bb50fcc4d7aa.svg";
export { ForwardRef as ReactComponent };